import { z } from 'zod';

export const GenericDataElementSchema = z.record(z.string(), z.any());
export const GenericDataListSchema = z.array(GenericDataElementSchema);

export type GenericDataElement = z.infer<typeof GenericDataElementSchema>;
export type GenericDataList = z.infer<typeof GenericDataListSchema>;
